<!--
  This component is used to create a form for submitting epassi payment.
  Props:
    transaction_id: String, required
    cartName: String, optional
    autoSubmit: Boolean, optional, default true
  Events:
    submitready: Function, emitted when the data is fetched and autoSubmit is set to false. The payload is the submit function of the component.
  Description:
    It requires a transaction_id prop to be passed to it. Data will be fetched when the transaction_id is set.
    If cartname is used, pass cartname as a prop to the component to clear after the transaction is complete.
-->
<template>
    <form class="d-none" action="" method="post" ref="epassiform" id="epassiform">
        <input type="hidden" name="STAMP" value="" />
        <input type="hidden" name="SITE" value="" />
        <input type="hidden" name="AMOUNT" value="" />
        <input type="hidden" name="REJECT" value="" />
        <input type="hidden" name="CANCEL" value="" />
        <input type="hidden" name="RETURN" value="" />
        <input type="hidden" name="VAT_VALUE" value="" />
        <input type="hidden" name="MAC" value="" />
        <input type="hidden" name="NOTIFY_URL" value="" />
        <input type="submit" />
    </form>
</template>

<script>
export default {
    name: 'zoezi-epassi',
    props: {
        transaction_id: {
            type: String,
            required: false,
            default: null
        },
        cartName: {
            type: String,
            required: false,
            default: null
        },
        autoSubmit: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    watch: {
        transaction_id: {
            handler(id) {
                if (id) {
                    this.fetchFormData();
                }
            },
            immediate: true
        }
    },
    methods: {
        fetchFormData() {
            let transaction_id = this.transaction_id;
            this.$api.get('/api/payment/epassi/get_data', { transaction_id }).then(res => {
                let missingField = false;

                if (this.cartName !== null) {
                    res['RETURN'] += `&epassi_cart=${this.cartName}`;
                }

                this.$refs.epassiform.action = res['URL'];
                this.$refs.epassiform.forEach((row) => {
                    if (row.type == 'submit') return;

                    if (!res[row.name]) {
                        missingField = true;
                    }
                    row.value = res[row.name];
                });

                if (!missingField) {
                    if (this.autoSubmit) {
                        this.submitEpassi();
                    } else {
                        this.$emit('submitready', this.submitEpassi);
                    }
                }
            }).catch( (e) => {
                e.json().then(data => {
                    this.$store.commit('showSnackBar', { text: this.$translate(data.message || 'Payment failed'), color: 'error' });
                    this.$emit('failed');
                }).catch(() => {
                    this.$store.commit('showSnackBar', { text: this.$translate('Payment failed'), color: 'error' });
                    this.$emit('failed');
                });
            })
        },
        submitEpassi() {
            // Event is sent to disable reservation cancellation on "beforeunload" when user is redirected to confrim epassi payment
            window.dispatchEvent(new CustomEvent('epassi-payment'));
            this.$refs.epassiform.submit();
        }
    },
}
</script>
